<template>
  <div class="mt-6">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Contenedores</h1>
      </div>
    </div>
    <div class="mt-4">
      <div v-show="!open" class="-my-2 overflow-x-auto">
        <div class="inline-block min-w-full py-2 align-middle">
          <div
            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
          >
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">Código</th>
                  <th scope="col" class="table-header-cell">Proceso</th>
                  <th scope="col" class="table-header-cell">
                    Planta de empaque
                  </th>
                  <th scope="col" class="table-header-cell">Cultivo</th>
                  <th scope="col" class="table-header-cell">Cliente</th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">{{ container.container_code }}</td>
                  <td class="table-cell">
                    {{ container.agro_exporter_process.name }}
                  </td>
                  <td class="table-cell">
                    {{ container.packing_house.name }}
                  </td>
                  <td class="table-cell">
                    {{ container.crop.name }}
                  </td>
                  <td class="table-cell">
                    {{ container.customer.name }}
                  </td>
                  <td class="table-cell-action">
                    <button
                      class="link"
                      @click="showContainerDetails(container)"
                    >
                      <i class="fa-solid fa-eye"></i>
                      <span class="space-icon"></span>Ver
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-show="open" class="bg-white py-3 rounded-md">
        <button @click="open = false" class="text-lg text-[#0d1f3c] px-6">
          <i class="fa-solid fa-chevron-left pr-2"></i>Volver a la lista
        </button>
        <div class="flex flex-col sm:px-6 justify-center">
          <div class="bg-white py-3 rounded-md pl-3">
            <div class="flex text-lg font-medium text-gray-900 justify-between">
              Contenedor: TEMU00123476
            </div>
            <div class="grid grid-cols-2 gap-x-2 gap-y-3 pl-3 text-gray-600">
              <span> Proceso: Mango 2021</span>
              <span> Planta de empaque: Apromalpi</span>
              <span>Cliente: Fairtrasa</span>
              <span>Pallets: 22</span>
            </div>
          </div>
        </div>
        <div class="flex inset-0 px-4 sm:px-6 justify-center">
          <div
            v-if="!show_pallet"
            class="grid grid-cols-2 gap-y-1.5 gap-x-5 h-[75vh] border-2 p-4 mx-8 shadow rounded-md w-full"
          >
            <div
              v-for="pallet in pallets"
              class="flex border border-gray-400 items-center rounded-md cursor-pointer"
              :class="{ 'hover:bg-blue-600': pallet.hover }"
              @mouseover.prevent="pallet.hover = true"
              @mouseleave="pallet.hover = false"
              @click="showPalletDetails(pallet)"
              :key="pallet"
            >
              <div
                :class="[
                  'text-center flex flex-1 flex-col',
                  pallet.hover ? 'text-white' : 'text-gray-700'
                ]"
              >
                <span :class="{ 'font-semibold': pallet.hover }">
                  Pallet: {{ pallet.pg_code }}
                </span>
                <span v-if="pallet.hover"> Packages: 1200 Kg </span>
                <span v-if="pallet.hover">Cultivo: Mango</span>
              </div>
            </div>
          </div>
          <div v-else class="inset-0 p-4 mx-8 w-full border-2 h-[75vh] rounded-md">
            <div class="text-lg font-medium text-gray-900">
              <button @click="show_pallet = false">
                <i class="fa-solid fa-chevron-left pr-4"></i>
              </button>
              Pallet: {{ pallet.pg_code }}
            </div>
            <div class="grid grid-cols-2 gap-2 pl-8 pt-6 pb-8 text-gray-600">
              <span>Cultivo: Mango</span>
              <span>Variedad: Kent</span>
              <span>Tipo de cultivo: Orgánico</span>
              <span>Total: 1072 Kg</span>
            </div>

            <table class="table px-4">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">Lote</th>
                  <th scope="col" class="table-header-cell">Productor</th>
                  <th scope="col" class="table-header-cell">Organización</th>
                  <th scope="col" class="table-header-cell">Total (Kg)</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr class="table-row">
                  <td class="table-cell">Lote-001</td>
                  <td class="table-cell">Juan Perez Perez</td>
                  <td class="table-cell">APAGRO</td>
                  <td class="table-cell">1728</td>
                </tr>
                <tr class="table-row">
                  <td class="table-cell">Lote-001</td>
                  <td class="table-cell">Juan Perez Perez</td>
                  <td class="table-cell">APAGRO</td>
                  <td class="table-cell">1728</td>
                </tr>
                <tr class="table-row">
                  <td class="table-cell">Lote-001</td>
                  <td class="table-cell">Juan Perez Perez</td>
                  <td class="table-cell">APAGRO</td>
                  <td class="table-cell">1728</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicProductionRequester from "../requesters/agroexporter/basic_production.js";
export default {
  name: "BasicProduction",
  components: {},
  data() {
    return {
      open: false,
      show_pallet: false,
      containers: [],
      container: null,
      pallets: [
        {
          pg_code: "PG-001",
          hover: false
        },
        {
          pg_code: "PG-002",
          hover: false
        },
        {
          pg_code: "PG-003",
          hover: false
        },
        {
          pg_code: "PG-004",
          hover: false
        },
        {
          pg_code: "PG-005",
          hover: false
        },
        {
          pg_code: "PG-006",
          hover: false
        },
        {
          pg_code: "PG-007",
          hover: false
        },
        {
          pg_code: "PG-008",
          hover: false
        },
        {
          pg_code: "PG-009",
          hover: false
        },
        {
          pg_code: "PG-010",
          hover: false
        },
        {
          pg_code: "PG-011",
          hover: false
        },
        {
          pg_code: "PG-012",
          hover: false
        },
        {
          pg_code: "PG-013",
          hover: false
        },
        {
          pg_code: "PG-014",
          hover: false
        },
        {
          pg_code: "PG-015",
          hover: false
        },
        {
          pg_code: "PG-016",
          hover: false
        },
        {
          pg_code: "PG-017",
          hover: false
        },
        {
          pg_code: "PG-018",
          hover: false
        },
        {
          pg_code: "PG-019",
          hover: false
        },
        {
          pg_code: "PG-020",
          hover: false
        },
        {
          pg_code: "PG-021",
          hover: false
        },
        {
          pg_code: "PG-022",
          hover: false
        }
      ],
      pallet: null
    };
  },
  props: {
    agroexporter_id: {
      required: true
    }
  },
  methods: {
    fetchContainers: async function () {
      let response = await BasicProductionRequester.listContainers(
        this.agroexporter_id
      );
      this.containers = response.data;
    },
    showContainerDetails: function (container) {
      this.container = container;
      this.open = true;
      // this.fetchPallets();
    },
    fetchPallets: async function () {
      let response = await BasicProductionRequester.listPallets(
        this.container.id
      );
      this.pallets = response.data;
      this.pallets.push(...response.data, ...response.data);
    },
    showPalletDetails: function (pallet) {
      this.pallet = pallet;
      this.show_pallet = true;
    }
  },
  beforeMount() {
    this.checkIfAuthenticated();
    this.fetchContainers();
  }
};
</script>
